import ErrorBoundary from "./containers/ErrorBoundaryContainer";

export * from "./components/ErrorBoundaryView";
export * from "./components/ErrorBoundaryBase";
export { ErrorBoundary };
